module.exports = __webpack_public_path__ + "img/schedule-demo-en.fb55764.png";